import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import relativeTime from 'dayjs/plugin/relativeTime'

dayjs.extend(relativeTime)
dayjs.extend(advancedFormat);

/**
 * @param  {string}       startDate
 * @param  {string}       endDate
 * @param  {string}     format
 * @return {Object[]}
 */
export function getDatesBetween(startDate, endDate, format = 'Do MMMM YYYY') {

    if (!startDate || !endDate) {
        return [];
    }

    const _startDate = dayjs(startDate);
    const _endDate = dayjs(endDate);

    const diff = parseInt(_endDate.diff(_startDate, 'd'));
    const dates = [];

    for (let i = 0; i < diff + 1; i++) {
        const date = _startDate.add(i, 'd');
        dates.push({
            value: date.format('YYYY-MM-DD'),
            label: date.format(format)
        });
    }
    return dates;
}

export function format(date, format = 'Do MMMM YYYY') {
    return dayjs(date).format(format);
}

export function addDays(date, days, format = 'Do MMMM YYYY') {
    const result = dayjs(date).add(days,'d');
    return result.format(format);
}

export function subtractDays(date, days, format = 'Do MMMM YYYY') {
    const result = dayjs(date).subtract(days,'d');
    return result.format(format);
}


/**
 *
 * @param {string} startDate
 * @param {string} endDate
 * @return {number}
 */
export function getDaysBetween(startDate, endDate) {
    return parseInt(dayjs(endDate).diff(dayjs(startDate), 'd'));
}
